import React, { Suspense, useEffect, useState } from "react";

import homePagePayload from "../../config/homePayload";
import homePageAPI from "../../api/homePageApi";

import CouponFlash from "./CouponFlash";
import { Link } from "react-router-dom";
import { Row, Col, Container } from "react-bootstrap";

import {
  Swiper,
  SwiperSlide,
  Autoplay,
  Navigation,
  Pagination,
} from "./Shared/CustomSwiper";
import { FaBox, FaCheckCircle, FaHeadset } from "react-icons/fa";
import History from "./History";
import Brand from "../brands/Brand";

const Product = React.lazy(() => import("../products/Card"));
const Testimonials = React.lazy(() => import("../testimonials/Card"));
const CategoryCard = React.lazy(() => import("../categories/Card"));
const Blog = React.lazy(() => import("../blogs/Card"));
const Banner = React.lazy(() => import("./Banner"));
const BrandsCard = React.lazy(() => import("../brands/Card"));
const ProductCard = React.lazy(() => import("../products/Card"));

function Home() {
  const [coupons, setCoupons] = useState([]);
  const [categories, setCategories] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [products, setProducts] = useState([]);
  const [topSellerProducts, setTopSellerProducts] = useState([]);
  const [blogs, setBlogs] = useState([]);
  const [topBanners, setTopBanners] = useState([]);
  const [middleBanners, setMiddleBanners] = useState([]);
  const firstMiddleBanner = middleBanners[0];
  const secondMiddleBanner = middleBanners[1];
  const [brands, setBrands] = useState([]);

  useEffect(() => {
    fetchHomePageDetails();
  }, []);

  const CACHE_TIME = 3 * 60 * 1000;

  const applyData = (data) => {
    setTopBanners(data?.banners?.filter((b) => b.position === "top"));
    setMiddleBanners(data?.banners?.filter((b) => b.position === "middle"));
    setCoupons(data?.coupons);
    setCategories(data?.categories);
    setTestimonials(data?.testimonials);
    setBlogs(data?.blogs);
    setProducts(data?.products);
    setTopSellerProducts(data?.topSellerProducts);
setBrands(data?.brands || []);  };

  const fetchHomePageDetails = async () => {
    try {
      const cached = sessionStorage.getItem("homeData");
      const parsed = cached ? JSON.parse(cached) : null;

      if (parsed) applyData(parsed.data);

      if (!parsed || Date.now() - parsed.timestamp > CACHE_TIME) {
        const res = await homePageAPI.homePage(homePagePayload);
        if (res.code === 200) {
          sessionStorage.setItem(
            "homeData",
            JSON.stringify({ data: res.data, timestamp: Date.now() }),
          );
          if (!parsed) applyData(res.data); // only update state if no cache was shown
        }
      }
    } catch (error) {
      console.error("Home API Error:", error);
    }
  };

  return (
    <>
      {/* show banners */}
      {topBanners && topBanners.length > 0 && (
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          slidesPerView={1}
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000 }}
          loop={true}
        >
          {topBanners.map((banner, index) => (
            <SwiperSlide key={index}>
              <Banner item={banner} />
            </SwiperSlide>
          ))}
        </Swiper>
      )}

      {/* coupon listing */}
      {/* Coupon Bar */}
      {coupons && coupons.length > 0 && (
        <div className="coupon-section py-4">
          <div className="container">
            <Suspense fallback={<div></div>}>
              {coupons.map((coupon, index) => (
                <React.Fragment key={index}>
                  <CouponFlash item={coupon} />
                </React.Fragment>
              ))}
            </Suspense>
          </div>
        </div>
      )}

      {/* category listing */}
      {categories && categories.length > 0 && (
        <section className="ith-cat-mini-section py-5">
          <div className="container-fluid px-lg-5">
            <div className="text-center mb-5">
              <span className="ith-section-subtitle">CATEGORY</span>
              <h3 className="ith-section-title">Shop by Category</h3>
            </div>

            <Swiper
              modules={[Navigation, Pagination]}
              spaceBetween={0} // Bhai padding yahan se zero kar di
              slidesPerView={2}
              navigation={true}
              // pagination={{ clickable: true }}
              breakpoints={{
                576: { slidesPerView: 3 },
                768: { slidesPerView: 4 },
                1024: { slidesPerView: 6 },
                1400: { slidesPerView: 6 },
              }}
              className="ith-category-mini-swiper"
            >
              {categories.map((category, index) => (
                <SwiperSlide key={index}>
                  <CategoryCard item={category} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </section>
      )}

    {products && products.length > 0 && (
  <section className="ith-explore-products-section py-5">
    <div className="container-fluid px-lg-5">
      <div className="ith-section-heading-row mb-5">
        <div className="ith-section-heading-left">
          <span className="ith-section-subtitle">PRODUCTS</span>
          <h2 className="ith-section-title">Explore Our Products</h2>
        </div>
        <Link to="/shop" className="ith-view-all-link">
          View All <i className="fas fa-arrow-right ms-2"></i>
        </Link>
      </div>

      <div className="row g-4 justify-content-center">
        <Suspense fallback={<div></div>}>
          {products.map((product, index) => (
            <div className="col-xl-4 col-lg-6 col-md-12" key={index}>
              <ProductCard product={product} />
            </div>
          ))}
        </Suspense>
      </div>
    </div>
  </section>
)}
      <History />

      {/* bestsellers */}
      {/* {products && products.length > 0 && (
        <section className="bestsellers-section main-section">
          <div className="container ">
            <h2 className="section-title text-center mb-4">Bestsellers</h2>
            <Row className="g-3">
              <Suspense fallback={<div></div>}>
                {products.map((product, index) => (
                  <Col lg={3} md={6} sm={6} xs={6} key={[product._id || index]}>
                    <Product item={product} />
                  </Col>
                ))}
              </Suspense>
            </Row>
          </div>
        </section>
      )} */}

      {/* middle banners */}
      {firstMiddleBanner && (
        <div className="middle-banner">
          <Container fluid className="p-0">
            <Row className="g-0 align-items-center">
              <Col md={7}>
                <div className="spotlight-image-wrapper">
                  <img
                    src={firstMiddleBanner.image}
                    alt="Sanwariya Ornaments"
                    className="spotlight-image"
                    loading="lazy"
                  />
                </div>
              </Col>

              <Col md={5} className="text-center p-md-5 p-3">
                <div className="spotlight-text-wrapper">
                  <span className="spotlight-tagline">Timeless Elegance</span>
                  <h2 className="spotlight-heading">
                    {firstMiddleBanner.title}
                  </h2>
                  <p className="spotlight-description">
                    {firstMiddleBanner.subTitle}
                  </p>
                  <Link to="/shop" className="spotlight-btn">
                    Discover More
                  </Link>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      )}

      {/* trending */}
      {/* {topSellerProducts && topSellerProducts.length > 0 && (
        <section className="bestsellers-section main-section mt-4">
          <div className="container ">
            <h2 className="section-title text-center mb-4">
              Trending Products
            </h2>
            <Row className="g-3">
              <Suspense fallback={<div></div>}>
                {topSellerProducts.map((product, index) => (
                  <Col lg={3} md={6} sm={6} xs={6} key={[product._id || index]}>
                    <Product item={product} />
                  </Col>
                ))}
              </Suspense>
            </Row>
          </div>
        </section>
      )} */}

      {/* category cta section */}
      {/* {secondMiddleBanner && (
        <section className="cta-banner-2 py-5">
          <Container>
            <Row className="align-items-center">
              <Col md={7} className="mb-4 mb-md-0">
                <div className="banner-media-wrapper">
                  <img
                    src={secondMiddleBanner.image}
                    alt={secondMiddleBanner.title}
                    className="banner-media"
                    loading="lazy"
                  />
                </div>
              </Col>

              <Col md={5}>
                <div className="banner-content-wrapper p-3 p-md-5">
                  <h2 className="banner-heading">{secondMiddleBanner.title}</h2>

                  <p className="banner-description">
                    {secondMiddleBanner.subTitle ||
                      secondMiddleBanner.sub_title}
                  </p>

                  <Swiper
                    spaceBetween={0}
                    slidesPerView={3}
                    loop
                    modules={[Navigation, Autoplay]}
                    breakpoints={{
                      0: { slidesPerView: 2.2 },
                      768: { slidesPerView: 2 },
                      1024: { slidesPerView: 3 },
                    }}
                    className="category-swiper"
                    autoplay={{ delay: 2500 }}
                  >
                    <Suspense fallback={<div></div>}>
                      {categories.map((cat, index) => (
                        <SwiperSlide key={index}>
                          <Link
                            to={`/categories/${cat.slug}`}
                            className="category-item"
                          >
                            <div className="category-circle">
                              <img
                                src={cat.image}
                                alt={cat.title || cat.name}
                                className="img-fluid"
                                loading="lazy"
                              />
                            </div>
                            <span>{cat.title || cat.name}</span>
                          </Link>
                        </SwiperSlide>
                      ))}
                    </Suspense>
                  </Swiper>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      )} */}

      {testimonials && testimonials.length > 0 && (
        <section className="ith-testimonial-section py-5">
          <div className="container-fluid px-lg-5">
            {/* Row ko yahan start kiya */}
            <div className="row g-5 align-items-center">
              {/* LEFT PART: Text Content (4 columns) */}
              <div className="col-xl-4 col-lg-5">
                <div className="ith-testimonial-title-box">
                  <span className="ith-section-subtitle">TESTIMONIALS</span>
                  <h2 className="ith-section-title mt-2">
                    What people saying about ITH
                  </h2>
                  <p className="text-muted mt-3">
                    Hear from our satisfied clients about their experience with
                    our industrial solutions and services.
                  </p>
                </div>
              </div>

              {/* RIGHT PART: Swiper Slider (8 columns) */}
              <div className="col-xl-8 col-lg-7">
                <Swiper
                  modules={[Autoplay, Pagination]}
                  spaceBetween={30}
                  slidesPerView={1}
                  loop={true}
                  autoplay={{ delay: 3000, disableOnInteraction: false }}
                  pagination={{ clickable: true, el: ".ith-custom-pagination" }}
                  breakpoints={{
                    768: { slidesPerView: 2 },
                    1200: { slidesPerView: 2 },
                  }}
                  className="ith-testimonial-swiper"
                >
                  <Suspense fallback={<div>Loading...</div>}>
                    {testimonials.map((testimonial, index) => (
                      <SwiperSlide key={index}>
                        <Testimonials item={testimonial} />
                      </SwiperSlide>
                    ))}
                  </Suspense>
                </Swiper>

                {/* Pagination dots slider ke niche */}
                <div className="ith-custom-pagination-wrapper mt-4">
                  <div className="ith-custom-pagination"></div>
                </div>
              </div>
            </div>{" "}
            {/* Row Ends Here */}
          </div>
        </section>
      )}

      {brands && brands.length > 0 && <Brand brands={brands} />}
    </>
  );
}

export default Home;
